module.exports = "<div class=\"key\">\r\n    <div class=\"key-value\">{{keyValue}}</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/shared/key/key.component.html
// module id = ../../../../../src/app/shared/key/key.component.html
// module chunks = main